<div class="toast padding-xs flex justify-content-space-between align-items-center" [class.toast-visible]="displayToastMessage">
    <div class="flex gap-xxs align-items-center margin-right-sm">
        <uvx-icon color="white">check circle</uvx-icon>
        <p class="toast-text">{{ message }}</p>
    </div>
    <uvx-icon class="pointer" color="white" (click)="displayToastMessage = false">close</uvx-icon>
</div>
